import { useAuth } from 'hooks/use-auth';
import { useTranslation } from 'react-i18next';
import { Event } from 'utils/helpers';
import { useLoginByEmailHook } from '../LoginByEmail/hooks';

export const useConfirmEmailHook = () => {
  const { t } = useTranslation();
  const { proceedToLogin } = useLoginByEmailHook();
  const {
    session,
    isConfirmEmailOpen,
    handleIsOpenConfirmEmailModal,
    handleIsOpenCheckOTPCodeOpen,
    handleIsOpenUserDuplicateModal,
    handleIsOpenRegisterModal,
  } = useAuth();

  const handleValidateEmail = () => {
    Event.push('getin_login_phone_checkmail_click');

    handleIsOpenConfirmEmailModal(false);
    handleIsOpenCheckOTPCodeOpen(true);
    handleIsOpenUserDuplicateModal(true);

    session?.email &&
      proceedToLogin({
        email: session?.email,
        userDuplicated: true,
      });
  };

  const handleClickBackButton = (isChangeEmailButton: boolean) => {
    if (isChangeEmailButton) {
      Event.push('getin_login_phone_changemail_click');
    }

    handleIsOpenConfirmEmailModal(false);
    handleIsOpenRegisterModal(true);
  };

  return {
    t,
    session,
    isConfirmEmailOpen,
    handleClickBackButton,
    handleValidateEmail,
    handleIsOpenConfirmEmailModal,
  };
};
